import { render, staticRenderFns } from "./CartTable.vue?vue&type=template&id=68ada779&scoped=true&"
import script from "./CartTable.vue?vue&type=script&lang=js&"
export * from "./CartTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ada779",
  null
  
)

export default component.exports